import { render, staticRenderFns } from "./palnModel.vue?vue&type=template&id=00824912&scoped=true"
import script from "./palnModel.vue?vue&type=script&lang=js"
export * from "./palnModel.vue?vue&type=script&lang=js"
import style0 from "./palnModel.vue?vue&type=style&index=0&id=00824912&lang=scss&scoped=true"
import style1 from "./palnModel.vue?vue&type=style&index=1&id=00824912&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00824912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00824912')) {
      api.createRecord('00824912', component.options)
    } else {
      api.reload('00824912', component.options)
    }
    module.hot.accept("./palnModel.vue?vue&type=template&id=00824912&scoped=true", function () {
      api.rerender('00824912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/additionalFrom/palnModel.vue"
export default component.exports